/** Record-list presentation only: consumers own controllers, permissions and scope.
 * Figma: API Keys 17:24645; Projects 26:120799.
 * Highlight semantics differ between frames: muted hover does not add selected state.
 * Blend semantic tokens locally because --border can equal --card in dark themes.
 */
const divider = "border-b border-[color:color-mix(in_srgb,var(--input-border),var(--foreground)_20%)]";

export const recordTable = {
  container: "min-w-0 overflow-x-auto",
  table: "w-full border-separate border-spacing-0 text-start text-sm",
  header: "h-9 text-foreground",
  headerCell: `h-9 bg-card px-2 text-start text-sm font-medium first:rounded-s-lg last:rounded-e-lg ${divider}`,
  row: "h-[60px] bg-background transition-colors motion-reduce:transition-none hover:bg-muted/40",
  cell: `px-2 py-2 text-start text-sm font-normal text-foreground ${divider}`,
  primary: "block text-sm font-normal leading-[21px] text-foreground",
  secondary: "block text-xs leading-[18px] text-foreground/70",
  actions: "flex items-center justify-end gap-1",
  action: "size-9 shrink-0 text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring",
  search: "h-9 bg-input ps-10 text-sm shadow-xs",
  searchIcon: "pointer-events-none absolute start-3 top-1/2 size-5 -translate-y-1/2 text-muted-foreground",
} as const;
